// plan-03 S03: cursor at 48 BPM — bible §15, §6

export interface CursorController {
  start: () => void
  stop: () => void
  attach: (el: HTMLElement) => void
  detach: () => void
  speedBurst: () => void
}

export function mountCursor(cursorEl: HTMLElement, home: HTMLElement): CursorController {
  let running = false
  let rafId = 0
  let phaseScale = 1.0 // normal = 1.0, burst = 0.5 (96 BPM)

  const ctrl: CursorController = {
    start() {
      if (running) return
      running = true
      tick()
    },
    stop() {
      running = false
      cancelAnimationFrame(rafId)
      cursorEl.style.opacity = '1'
    },
    attach(el: HTMLElement) {
      el.appendChild(cursorEl)
    },
    detach() {
      // return cursor to its home (the input form) instead of orphaning it
      home.appendChild(cursorEl)
    },
    speedBurst() {
      phaseScale = 0.5 // 96 BPM for one cycle
      setTimeout(() => {
        phaseScale = 1.0
      }, 1250) // one full 48 BPM cycle
    },
  }

  function tick(): void {
    if (!running) return
    rafId = requestAnimationFrame(tick)

    const reduced = document.body.classList.contains('vt-reduced-motion')
    const period = 1.25 / phaseScale // 1.25s at 48 BPM, 0.625s at 96 BPM
    const scaledPeriod = reduced ? period * 2 : period // 24 BPM in reduced-motion
    const seconds = performance.now() / 1000
    const phase = (seconds % scaledPeriod) / scaledPeriod

    cursorEl.style.opacity = phase < 0.5 ? '1' : '0'
    cursorEl.style.transition = 'none'
  }

  return ctrl
}
